import { send_to_server } from '@/services/socketio_client_react/send_to_server';
import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { ENUM__network_event_client_to_server } from '@shared/network/ENUM__network_event_client_to_server';
import { createAsyncThunkSafe } from '../_base/createAsyncThunkSafe';
import { StateMLAsset } from './state_ml_asset';

export const remote_ml_asset_get_by_id = createAsyncThunkSafe(
  ENUM__network_event_client_to_server.ML_ASSET_GET_BY_ID,
  async (diffusion_model_ids: string[]) => {
    await send_to_server(ENUM__network_event_client_to_server.ML_ASSET_GET_BY_ID, diffusion_model_ids);
  },
);

export function init_remote_ml_asset_get_by_id(builder: ActionReducerMapBuilder<StateMLAsset>) {
  builder
    .addCase(remote_ml_asset_get_by_id.pending, (state, action) => {
      let ids = action.meta.arg;

      for (let id of ids) {
        state.models_loading_in_progress.add(id);
      }

      //need for force re-render
      state.models_loading_in_progress = new Set(state.models_loading_in_progress);
    })
    .addCase(remote_ml_asset_get_by_id.rejected, (state, action) => {})
    .addCase(remote_ml_asset_get_by_id.fulfilled, (state, action: PayloadAction<void>) => {});
}
